<template>
  <div>
    <Head title="Customers" />
    <h1 class="moul flex items-center mb-8 text-2xl"><UserGroupIcon class="mr-2 w-8 h-8" /> អតិថិជន</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">ភេទ:</label>
        <select v-model="form.gender" class="form-select mt-1 w-full">
          <option :value="null">បង្ហាញទាំងអស់</option>
          <option value="ប្រុស">បង្ហាញតែភេទប្រុស</option>
          <option value="ស្រី">បង្ហាញតែភេទស្រី</option>
        </select>

        <label class="block mt-4 text-gray-700">ស្ថានភាព:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">បង្ហាញតែអតិថិជនមិនបានលុប</option>
          <option value="with">ជាមួយអតិថិជនដែលបានលុប</option>
          <option value="only">បង្ហាញតែអតិថិជនដែលបានលុប</option>
        </select>
      </search-filter>

      <Link class="btn-indigo flex items-center" href="/contacts/create">
        <PlusIcon class="mr-1 w-4 h-4" />
        <span>បង្កើត</span>
        <span class="hidden md:inline">ថ្មី</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left">
          <th class="pb-4 pt-6 px-6">ID អតិថិជន</th>
          <th class="pb-4 pt-6 px-6">ឈ្មោះពេញ</th>
          <th class="pb-4 pt-6 px-6">ភេទ</th>
          <th class="pb-4 pt-6 px-6">លេខទូរសព្ទ</th>
          <th class="pb-4 pt-6 px-6">ចំនួនខ្ចី</th>
          <th class="pb-4 pt-6 px-6" colspan="2">អាសយដ្ឋាន</th>
        </tr>
        <tr v-for="contact in contacts.data" :key="contact.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              {{ contact.customer_id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/contacts/${contact.id}/edit`">
              {{ contact.name }}
              <icon v-if="contact.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              <div v-if="contact.gender">
                {{ contact.gender }}
              </div>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              {{ contact.phone }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              {{ contact.loan_count }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1"> {{ contact.address }} </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="contacts.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="5">មិនមានអតិថិជនត្រូវបង្ហាញទេ!</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="contacts.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { UserGroupIcon, PlusIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    UserGroupIcon,
    PlusIcon,
  },
  layout: Layout,
  props: {
    filters: Object,
    contacts: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        gender: this.filters.gender,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/contacts', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
